// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type WorkspaceBookmarksQueryVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type WorkspaceBookmarksQuery = (
  { __typename?: 'Query' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
    & { bookmarkList: Array<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    & { bookmarkList: Array<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
    & { bookmarkList: Array<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id' | 'title' | 'url' | 'type'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PrivateImageWithVariants' }
        & Pick<PrivateSchemaTypes.PrivateImageWithVariants, 'original'>
        & { largeCdnUrl: PrivateSchemaTypes.PrivateImageWithVariants['variantCdnUrl'] }
      )> }
    )> }
  )> }
);

export type RemoveBookmarkMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  bookmarkId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveBookmarkMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
    & { bookmark?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id'>
      & { remove?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
        & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id'>
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id'>
    & { bookmark?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id'>
      & { remove?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
        & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id'>
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
    & { bookmark?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id'>
      & { remove?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'WorkspaceBookmarkModelAsCoordinator' }
        & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsCoordinator, 'id'>
      )> }
    ) | (
      { __typename?: 'WorkspaceBookmarkModelAsMember' }
      & Pick<PrivateSchemaTypes.WorkspaceBookmarkModelAsMember, 'id'>
    )> }
  )> }
);

export type SetBookmarksTypeMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  targetType: PrivateSchemaTypes.WorkspaceBookmarkTypeEnum;
}>;


export type SetBookmarksTypeMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'setBookmarksType' | 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);

export type SetBookmarksOrderMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  orderOfIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type SetBookmarksOrderMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'setBookmarksOrder' | 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);


export const WorkspaceBookmarksDocument = gql`
    query workspaceBookmarks($workspaceId: PositiveInt!) {
  workspace(id: $workspaceId) {
    id
    bookmarkList {
      id
      title
      url
      type
      image {
        original
        largeCdnUrl: variantCdnUrl(imageSize: large)
      }
    }
  }
}
    `;

/**
 * __useWorkspaceBookmarksQuery__
 *
 * To run a query within a React component, call `useWorkspaceBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceBookmarksQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceBookmarksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceBookmarksQuery, WorkspaceBookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceBookmarksQuery, WorkspaceBookmarksQueryVariables>(WorkspaceBookmarksDocument, options);
      }
export function useWorkspaceBookmarksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceBookmarksQuery, WorkspaceBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceBookmarksQuery, WorkspaceBookmarksQueryVariables>(WorkspaceBookmarksDocument, options);
        }
export type WorkspaceBookmarksQueryHookResult = ReturnType<typeof useWorkspaceBookmarksQuery>;
export type WorkspaceBookmarksLazyQueryHookResult = ReturnType<typeof useWorkspaceBookmarksLazyQuery>;
export type WorkspaceBookmarksQueryResult = Apollo.QueryResult<WorkspaceBookmarksQuery, WorkspaceBookmarksQueryVariables>;
export const RemoveBookmarkDocument = gql`
    mutation removeBookmark($workspaceId: PositiveInt!, $bookmarkId: PositiveInt!) {
  workspace(id: $workspaceId) {
    id
    bookmark(id: $bookmarkId) {
      id
      ... on WorkspaceBookmarkModelAsCoordinator {
        remove {
          id
        }
      }
    }
  }
}
    `;
export type RemoveBookmarkMutationFn = Apollo.MutationFunction<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;

/**
 * __useRemoveBookmarkMutation__
 *
 * To run a mutation, you first call `useRemoveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookmarkMutation, { data, loading, error }] = useRemoveBookmarkMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      bookmarkId: // value for 'bookmarkId'
 *   },
 * });
 */
export function useRemoveBookmarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>(RemoveBookmarkDocument, options);
      }
export type RemoveBookmarkMutationHookResult = ReturnType<typeof useRemoveBookmarkMutation>;
export type RemoveBookmarkMutationResult = Apollo.MutationResult<RemoveBookmarkMutation>;
export type RemoveBookmarkMutationOptions = Apollo.BaseMutationOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;
export const SetBookmarksTypeDocument = gql`
    mutation setBookmarksType($workspaceId: PositiveInt!, $targetType: WorkspaceBookmarkTypeEnum!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      setBookmarksType(targetType: $targetType)
    }
  }
}
    `;
export type SetBookmarksTypeMutationFn = Apollo.MutationFunction<SetBookmarksTypeMutation, SetBookmarksTypeMutationVariables>;

/**
 * __useSetBookmarksTypeMutation__
 *
 * To run a mutation, you first call `useSetBookmarksTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBookmarksTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBookmarksTypeMutation, { data, loading, error }] = useSetBookmarksTypeMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useSetBookmarksTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetBookmarksTypeMutation, SetBookmarksTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetBookmarksTypeMutation, SetBookmarksTypeMutationVariables>(SetBookmarksTypeDocument, options);
      }
export type SetBookmarksTypeMutationHookResult = ReturnType<typeof useSetBookmarksTypeMutation>;
export type SetBookmarksTypeMutationResult = Apollo.MutationResult<SetBookmarksTypeMutation>;
export type SetBookmarksTypeMutationOptions = Apollo.BaseMutationOptions<SetBookmarksTypeMutation, SetBookmarksTypeMutationVariables>;
export const SetBookmarksOrderDocument = gql`
    mutation setBookmarksOrder($workspaceId: PositiveInt!, $orderOfIds: [PositiveInt!]!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      setBookmarksOrder(orderOfIds: $orderOfIds)
    }
  }
}
    `;
export type SetBookmarksOrderMutationFn = Apollo.MutationFunction<SetBookmarksOrderMutation, SetBookmarksOrderMutationVariables>;

/**
 * __useSetBookmarksOrderMutation__
 *
 * To run a mutation, you first call `useSetBookmarksOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBookmarksOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBookmarksOrderMutation, { data, loading, error }] = useSetBookmarksOrderMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      orderOfIds: // value for 'orderOfIds'
 *   },
 * });
 */
export function useSetBookmarksOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetBookmarksOrderMutation, SetBookmarksOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetBookmarksOrderMutation, SetBookmarksOrderMutationVariables>(SetBookmarksOrderDocument, options);
      }
export type SetBookmarksOrderMutationHookResult = ReturnType<typeof useSetBookmarksOrderMutation>;
export type SetBookmarksOrderMutationResult = Apollo.MutationResult<SetBookmarksOrderMutation>;
export type SetBookmarksOrderMutationOptions = Apollo.BaseMutationOptions<SetBookmarksOrderMutation, SetBookmarksOrderMutationVariables>;